export const PageDataState = {
    Searchs: {
        course_eb_02_id: {
            type: 'text',
            id: 'course_eb_02_id',
            label: '',
            value: '',
        },
        expense_category_name: {
            type: 'text',
            id: 'expense_category_name',
            label: 'หมวดค่าใช้จ่าย',
            value: '',
            placeholder: 'หมวดค่าใช้จ่าย',
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        course_eb_02_id: {
            type: 'select',
            id: 'course_eb_02_id',
            label: 'หลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        expense_category_id: {
            type: 'select',
            id: 'expense_category_id',
            label: 'หมวดค่าใช้จ่าย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }, 
        multiplier_details: {
            type: 'text',
            id: 'multiplier_details',
            label: 'รายละเอียดตัวคูณ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },                
        budget: {
            type: 'text',
            id: 'budget',
            label: 'งบประมาณ (บาท)',
            value: '',
            validator: {
                type: 'number',
                required: true,
                minLength: 100,
                maxLength: 100000
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        }      
    },
    InputGroup: {}
}